/* ESM wrapper for CommonJS other to provide a stable default export */
const cjs = require('./other');
const other = (cjs && cjs.default && cjs.default !== cjs) ? cjs.default : cjs;
export default other;

